import { render, staticRenderFns } from "./edit-avatar.vue?vue&type=template&id=cec3438a&"
import script from "./edit-avatar.js?vue&type=script&lang=js&"
export * from "./edit-avatar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports